import { Outlet } from 'react-router'

const OperationsMainLayout = () => {
  return (
    <Outlet />
  )
}

export default OperationsMainLayout